<div class="dialog-content-wrapper">
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center">
      <span class="title dialog-title">
        <span *ngIf="result?.status === 0" i18n>Заказ добавлен в корзину</span>
        <span *ngIf="result?.status === 1" i18n>Ошибка при добавлении заказа</span>
      </span>
      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-4 m-0" fusePerfectScrollbar>
    <a
      mat-raised-button
      i18n
      *ngIf="result?.status === 0 && result?.cartLink"
      href="{{ result?.cartLink }}"
      target="_blank"
      rel="noopener noreferrer"
      >Перейти в корзину</a
    >

    <span *ngIf="result?.status !== 0">
      {{ result?.errorText }}
    </span>
  </div>

  <div mat-dialog-actions class="flex flex-row justify-end items-center m-0 p-4">
    <button i18n type="button" mat-raised-button class="mat-accent mr-4" (click)="dialogRef.close()">ОК</button>
  </div>
</div>
